import { gql } from "@apollo/client";

import IOperation from "api/IOperation";
/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

import { BusinessQuery as BusinessQueryType, BusinessQueryVariables } from "gql/types/queries/BusinessQuery";

const text = gql`query BusinessQuery($businessInput: QueryBusinessInput!) {
	business(businessInput: $businessInput) {
		id
		slug
		name
		localeNames
		locales
		description
		timeZone
		displayBusinessHours
		displayPhoneNumber
		phoneNumber
		websiteUrl
		logoUrl
		faviconUrl
		mapUrl
		email
		theme
		orderIntervalMinutes
		orderAheadMaxDays
		stripeAccountId
		pause

		businessLinks {
			provider
			url
		}
		taxRate

		address {
			address1
			address2
			address3
			city
			state
			postalCode
			country
			coordinates {
				latitude
				longitude
			}
			placeId
			place
		}

		categories {
			id
			name
			localeNames
		}

		orderTypes {
			id
			orderType
			name
			localeNames
			description
			freeAfterOrderTotalCents
			priceCents
			isDeliveryTaxable
			deliveryRadiusMeters
			defaultPreparationTimeMinutes
			deliveryTimeMaxMinutes
			effectiveAvailability {
				hours {
					daysOfWeek
					intervals {
						startTime
						endTime
					}
				}
				exceptions {
					startsAt
					endsAt
				}
			}
		}

		menus {
			id
			slug
			name
			localeNames

			menuGroups {
				id
				slug
				name
				displayOrder
				description
				localeNames

				availability {
					hours {
						daysOfWeek
						intervals {
							startTime
							endTime
						}
					}
					exceptions {
						startsAt
						endsAt
					}
				}

				menuItems {
					id
					itemCode
					name
					localeNames
					description
					priceCents
					displayOrder
					displayPrice
					outOfStock
					imageUrl
					preparationTimeMinutes

					menuGroup {
						id

						availability {
							hours {
								daysOfWeek
								intervals {
									startTime
									endTime
								}
							}
							exceptions {
								startsAt
								endsAt
							}
						}

						menu {
							id

							business {
								id
							}
						}
					}

					menuItemOptionGroups {
						id
						name
						localeNames
						description
						displayOrder
						minCount
						maxCount

						menuItemOptions {
							id
							itemCode
							name
							localeNames
							imageUrl
							priceCents
							displayPrice
							preparationTimeMinutes
							outOfStock
						}
					}

					disableSpecialInstructions
				}
			}
		}
	}
}
`;

const BusinessQuery: IOperation<BusinessQueryType, BusinessQueryVariables> = { text } as any;

export default BusinessQuery;
